import {onMounted, onUnmounted, ref} from "vue";

function getAlturaJanela() {
  return window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
}

export function useResize() {
  const altura_janela = ref(getAlturaJanela())

  function setAlturaJanela() {
    altura_janela.value = getAlturaJanela()
  }

  onMounted(() => window.addEventListener("resize", setAlturaJanela));
  onUnmounted(() => window.addEventListener("resize", setAlturaJanela));

  return { altura_janela }
}
